export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

export const USER_ROLES = {
  ADMIN: 'admin',
  CASHIER: 'cashier',
  MANAGER: 'manager'
};

export const ORDER_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  READY: 'ready',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  PARTIAL: 'partial',
  REFUNDED: 'refunded'
};

export const PAYMENT_METHODS = {
  CASH: 'cash',
  CARD: 'card',
  KNet: 'knet',
  WALLET: 'wallet'
};

export const SERVICE_TYPES = {
  WASH: 'wash',
  DRY_CLEAN: 'dry_clean',
  IRON: 'iron',
  WASH_IRON: 'wash_iron'
};

export const STATUS_COLORS = {
  pending: '#F59E0B',
  in_progress: '#3B82F6',
  ready: '#10B981',
  completed: '#6B7280',
  cancelled: '#EF4444',
  paid: '#10B981'
};